module.exports = __webpack_public_path__ + "img/Net5-Logo.b6d78ee1.png";